import clearAgencyTwilio from './clear-agency-twilio'
import setDefaultOutboundNumber from './set-default-inbound-number'
import setNumberPoolsLookupTable from './set-number-pools-lookup-table'
import setPhoneNumbersA2PLookup from  "./set-phone-numbers-a2p-lookup"
import setPhoneNumbersLookupTable from './set-phone-numbers-lookup-table'
import setTable from './set-table'
import setTollFreeData from "./set-tollfree-data"
import setTollFreeDataAt from "./set-tollfree-data-at"
import setA2PRestrictionByCompany from "./set-a2p-restriction-by-company"

const mutations = {
  clearAgencyTwilio,
  setDefaultOutboundNumber,
  setNumberPoolsLookupTable,
  setPhoneNumbersA2PLookup,
  setPhoneNumbersLookupTable,
  setTable,
  setTollFreeData,
  setTollFreeDataAt,
  setA2PRestrictionByCompany,

  setStripe(state, payload: any) {
    state.stripe = payload
  },

  setAgencyTwilio(state, payload) {
    state.agencyTwilio = payload
  },

  startLoading(state) {
    state.loading = true
  },

  startModalLoading(state) {
    state.modalLoading = true
  },

  stopLoading(state) {
    state.loading = false
  },

  stopModalLoading(state) {
    state.modalLoading = false
  },

  setLocationId(state, locationId: string) {
    state.locationId = locationId
  },

  setTableRecordsCount(state, renderedRecordsCount: number) {
    state.renderedRecordsCount = renderedRecordsCount ?? 0
  },

  setTotalPhoneNumbers(state, totalPhoneNumbers: number) {
    state.totalPhoneNumbers = totalPhoneNumbers
  },

  setTotalNumberPools(state, totalNumberPools: number) {
    state.totalNumberPools = totalNumberPools
  },

  setTotalVerifiedCallerIDs(state, totalVerifiedCallerIDs: number) {
    state.totalVerifiedCallerIDs = totalVerifiedCallerIDs
  },

  setPhoneNumbers(state, phoneNumbers: any[]) {
    state.phoneNumbers = []
    state.phoneNumbers = phoneNumbers
  },

  setPhoneNumbersPaginated(state, phoneNumbersObj: any) {
    const { page, phoneNumbers, isUnderGHL, totalPages } = phoneNumbersObj
    // state.phoneNumbersPaginated = {}
    state.phoneNumbersCurrentPage = page
    state.phoneNumbersPaginated[page] = phoneNumbers
    state.phoneNumbersIsUnderGHL = isUnderGHL
    state.phoneNumbersTotalPages = totalPages
  },

  resetPhoneNumbersPaginated(state, data) {
    const { page } = data;
    if (!page) {
      state.phoneNumbersPaginated = {}
    } else {
      state.phoneNumbersPaginated[page] = []
    }
  },

  setLinkedNumbers(state, linkedNumbers: any) {
    state.linkedNumbers = []
    state.linkedNumbers = linkedNumbers
  },

  setNumberPools(state, numberPools: any[]) {
    state.numberPools = []
    state.numberPools = numberPools
  },

  setNumberPoolIDs(state, numberPoolIDs: string[]) {
    state.numberPoolIDs = []
    state.numberPoolIDs = numberPoolIDs
  },

  setLocationTwilio(state, locationTwilio: any) {
    state.locationTwilio = {}
    state.locationTwilio = locationTwilio
  },

  setCallerIDs(state, callerIDs: any[]) {
    state.callerIDs = []
    state.callerIDs = callerIDs
  },

  setA2PComplianceStatus(state, status: string) {
    state.a2pComplianceStatus = ''
    state.a2pComplianceStatus = status
  },

  clearPhoneNumbersLookupTable(state) {
    state.phoneNumbersSIDIndexLookup = {}
  },

  clearMapPhoneNumberSID(state) {
    state.mapPhoneNumberSID = {}
  },

  setPhoneNumbersSID(state, SIDMap: any) {
    state.phoneNumbersSID = []
    state.phoneNumbersSID = SIDMap
  },

  setAccount3DSInfo(state, data: any) {
    state.account3DSInfo = null
    state.account3DSInfo = data
  },

  setCustomerPayment(state, data: any) {
    state.customerPayment = null
    state.customerPayment = data
  },
  setRCBundleList(state, bundles: any) {
    state.RCBundleList = {}
    state.RCBundleList = bundles
  },
  setRCAddressList(state, address: any) {
    state.RCAddressList = []
    state.RCAddressList = address
  },
  setLocationBlackListConfig(state, data: any) {
    if (data?.status) {
      state.locationTwilio.blacklistConfig = {
        smsSuspensionTill : null,
        isLocationSuspended: false
      }
    }
  }

}


export default mutations
